export default "https://cdn-static.gokick.com/assets/545fd9dea55dc30417fabffa3a2a88024697daac/images/sleep-green-apple.f225c952c3b7c02c96ff4f722551ea5d.png";